import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const setObjectiveApi = createApi({
  reducerPath: 'setObjectives',
  tagTypes: ['SetObjective'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchSetObjectives: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'SetObjective', id: 'LIST' },
                ...result.map((r) => ({ type: 'SetObjective', id: r.id })),
              ]
            : [{ type: 'SetObjective', id: 'LIST' }],
        query: () => ({
          url: `?resource=set_objective`,
          method: 'GET',
        }),
      }),

      createSetObjective: builder.mutation({
        // Invalida la lista de sets y también el workout que los contiene
        invalidatesTags: [
          { type: 'SetObjective', id: 'LIST' },
          { type: 'Workout', id: 'LIST' },
        ],
        query: (data) => ({
          url: `?resource=set_objective`,
          method: 'POST',
          body: data,
          headers: {
            Prefer: 'return=representation',
            'Content-Type': 'application/json',
          },
        }),
      }),

      updateSetObjective: builder.mutation({
        // Invalida el set específico y el workout que lo contiene
        invalidatesTags: (result, error, { id: setObjectiveId }) => [
          { type: 'SetObjective', id: setObjectiveId },
          { type: 'Workout', id: 'LIST' },
        ],
        query: ({ id: workoutId, submitData }) => ({
          url: `?resource=set_objective&id=eq.${workoutId}`,
          method: 'PATCH',
          body: submitData,
          headers: {
            'Content-Type': 'application/json',
          },
        }),
      }),

      deleteSetObjective: builder.mutation({
        invalidatesTags: (result, error, setObjectiveId) => [
          { type: 'SetObjective', id: setObjectiveId },
          { type: 'SetObjective', id: 'LIST' },
          { type: 'Workout', id: 'LIST' },
        ],
        query: (workoutId) => ({
          url: `?resource=set_objective&id=eq.${workoutId}`,
          method: 'DELETE',
        }),
      }),

      fetchSetObjective: builder.query({
        providesTags: (result, error, arg) => [{ type: 'SetObjective', id: arg }],
        query: (workoutId) => ({
          url: `?resource=set_objective&id=eq.${workoutId}`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchSetObjectivesQuery,
  useCreateSetObjectiveMutation,
  useUpdateSetObjectiveMutation,
  useDeleteSetObjectiveMutation,
  useFetchSetObjectiveQuery,
} = setObjectiveApi;

export { setObjectiveApi };
